import { useCallback } from 'react';

import { useEndpoint } from 'api';
import { useChatContext, useGlobalPopoversContext } from 'contexts';

import { useLazyGlobalValue } from './useLazyGlobalValue';

export function useChat(isAvailabilityActive = false) {
	const {
		activateChatWidget,
		chatWidgetIsActive,
		chatWidgetIsReady,
		messageCount,
	} = useChatContext();

	const { openCustomerChat } = useGlobalPopoversContext();
	const { data, isLoading } = useEndpoint('GetCustomerAvailability', {
		isActive: isAvailabilityActive,
	});
	const Smooch = useLazyGlobalValue('Smooch', { isActive: chatWidgetIsActive });

	const openChat = useCallback(() => {
		// Calling Smooch methods before init will throw errors.
		if (Smooch && chatWidgetIsReady) {
			Smooch.open?.();
		}
	}, [Smooch, chatWidgetIsReady]);

	return {
		activateChatWidget,
		/** Chat system has agents available to respond */
		chatHasAvailableAgents: Boolean(data?.available),
		/** Chat system itself is open at all */
		chatIsOpen: Boolean(data?.open),
		/** Chat widget should be loaded */
		chatWidgetIsActive,
		/** Chat widget is initialized and ready to use */
		chatWidgetIsReady,
		/** Loading status for chat system available/open */
		isLoadingChatAvailability: isLoading,
		/** Chat widget script is loading */
		isLoadingChatWidget: chatWidgetIsActive && !chatWidgetIsReady,
		messageCount,
		openChat,
		openChatOrPopover: chatWidgetIsActive ? openChat : openCustomerChat,
		Smooch,
		zendeskJwt: data?.zendeskJwt,
	};
}
